import { useContext, useState } from 'react';
import { Form, Input, Button, Select, Space, Divider, message } from 'antd';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { AppStorage, RestAPI, ToEnglish, useAsyncClick } from 'scripts';
import { GlobalContext } from 'context';
import styles from '../signupOTP.module.scss';
import { API, PATH } from 'data';
import { __PhoneData } from './firstStep.data';
import { __RegisterType } from '../signupOTP.type';
import { __LoginFirstStepPropsType } from './firstStep.type';
import { Rule } from 'antd/es/form';
import { AppLinkComp } from 'components';
import { useSearchParams } from 'next/navigation';
export default function LoginFirstStepComp(props: __LoginFirstStepPropsType) {
  polyfillCountryFlagEmojis();
  const langText = useContext(GlobalContext).langText;
  const lang = langText.signupOTP;
  const [search, setSearch] = useState('');
  const terms = lang.terms.split('--');
  const params = useSearchParams();
  const noCodeAccess = !!Number(process.env.NEXT_PUBLIC_DISABLE_CODE_REGISTRATION);
  const phoneHandler = useAsyncClick((values: __RegisterType) => {
    return new Promise(resolve => {
      AppStorage.authToken.remove();
      const phone = `${noCodeAccess ? '' : values.prefix.split('|')[0]}${ToEnglish(values.phone)}`;
      RestAPI.post(API.register.passwordRegister, {
        phone,
        password: values.password,
        first_name: values.name,
        last_name: values.name
      }).then(props.onNext).catch(() => message.error(lang.error)).then(() => resolve(true));
    });
  });
  const confirmRule: Rule = ({
    getFieldValue
  }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') === value) return Promise.resolve();
      return Promise.reject(new Error(lang.confirmErr2));
    }
  });
  const onChangeForm = () => {
    const values = props.phoneForm.getFieldsValue();
    props.phoneForm.setFields(Object.keys(values).map(i => ({
      name: i,
      errors: undefined
    })));
  };
  return <Form<__RegisterType> layout="vertical" form={props.phoneForm} name="phone" onFinish={phoneHandler.onClick} onChange={onChangeForm} className={props.step === 'phone' ? '' : 'd-none-i'} data-sentry-element="Form" data-sentry-component="LoginFirstStepComp" data-sentry-source-file="firstStep.index.tsx">
            <Form.Item<__RegisterType> name="phone" label={lang.phone} validateTrigger={false} rules={[{
      required: true,
      message: lang.phoneRequired
    }]} data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx">
                <Input autoComplete="nope" addonBefore={<Form.Item<__RegisterType> name="prefix" noStyle rules={[{
        required: true
      }]} initialValue={__PhoneData.find(i => i.desc === 'Canada')?.value}>
                            <Select popupMatchSelectWidth={false} optionLabelProp="newLabel" options={__PhoneData.filter(i => i.value === 'divider' ? 1 : search.length ? ToEnglish(i.label).includes(search) || i.desc.toLowerCase().includes(search.toLowerCase()) : 1)} dropdownRender={menu => <>
                                        <Space.Compact className="p-1" style={{
            maxWidth: 275
          }}>
                                            <Input onChange={s => setSearch(s.target.value)} allowClear placeholder={lang.search} />
                                        </Space.Compact>
                                        <Divider style={{
            margin: '8px 0'
          }} />
                                        {menu}
                                    </>} optionRender={option => option.data.short !== 'divider' ? <Space>
                                            <span role="img" style={{
            fontFamily: 'Twemoji Country Flags'
          }} aria-label={option.data.label}>
                                                {option.data.emoji}
                                            </span>
                                            {option.data.desc.substring(0, 25) + (option.data.desc.length > 25 ? '...' : '')}
                                        </Space> : <Divider className="m-0-i" />} />
                        </Form.Item>} className={`${styles['input-phone']} w-100`} data-sentry-element="Input" data-sentry-source-file="firstStep.index.tsx" />
            </Form.Item>
            <Form.Item<__RegisterType> name="password" label={lang.password} validateTrigger={false} rules={[{
      required: true,
      message: lang.passwordErr
    }, {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&])[A-Za-z0-9@$!%*?&]{8,}$/,
      message: lang.passwordErr2
    }]} data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx">
                <Input.Password autoComplete="new-password" type="password" data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx" />
            </Form.Item>
            <Form.Item<__RegisterType> name="confirm" label={lang.confirmPass} dependencies={['password']} rules={[{
      required: true,
      message: lang.confirmErr
    }, confirmRule]} data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx">
                <Input.Password data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx" />
            </Form.Item>
            <Form.Item<__RegisterType> name="name" label={lang.name} validateTrigger={false} rules={[{
      required: true,
      message: lang.nameErr
    }]} data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx">
                <Input data-sentry-element="Input" data-sentry-source-file="firstStep.index.tsx" />
            </Form.Item>
            <p className=" t-p2">
                {terms[0]}
                <a href={PATH(langText.lang).terms} className="t-p2" target="_blank">
                    {terms[1]}
                </a>
                {terms[2]}
            </p>
            <p className="mt-2 t-p2">
                {lang.hasAccount}{' '}
                <AppLinkComp href={PATH(langText.lang).login(params.get('redirect') ?? undefined)} className="t-primary" data-sentry-element="AppLinkComp" data-sentry-source-file="firstStep.index.tsx">
                    {lang.login}
                </AppLinkComp>
            </p>
            <Form.Item className="m-0-i" data-sentry-element="unknown" data-sentry-source-file="firstStep.index.tsx">
                <Button loading={phoneHandler.loading} htmlType="submit" className={`w-100 mt-5`} data-sentry-element="Button" data-sentry-source-file="firstStep.index.tsx">
                    {lang.sendPhone}
                </Button>
            </Form.Item>
        </Form>;
}